module.exports = __webpack_public_path__ + "img/main-site.2d219297.svg";